/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IViewSecurityMatrixModalControllerScope extends IBaseModalControllerScope {
        securityMatrixId: string;
        securityMatrixViewDto: Wars.Domain.Model.Dtos.SecurityMatrixViewDto;
        flatRows: Wars.Domain.Model.Dtos.FlatSecurityMatrixRowDto[];
        mergedRows: Wars.Domain.Model.Dtos.FlatSecurityMatrixRowDto[];
        criteria: any;
        filterRows(): void;
        flatRowsToUse(): Wars.Domain.Model.Dtos.FlatSecurityMatrixRowDto[];
    }

    export class ViewSecurityMatrixModalController extends BaseModalController {
        scope: IViewSecurityMatrixModalControllerScope;

        constructor(
            private $scope: IViewSecurityMatrixModalControllerScope,
            private securityMatrixService: services.SecurityMatrixService,
            securityMatrixId: string,
            close: any) {
            super($scope, close);
            this.scope = $scope;
            this.scope.securityMatrixId = securityMatrixId;
            this.scope.flatRowsToUse = () => this.flatRowsToUse();
            this.scope.filterRows = () => this.filterRows();

            this.initialize();
        }

        private initialize(): void {
            this.$scope.criteria = {
                statusFilterText: '',
                authorityFilter: 'NONE',
                combineLikeRoles: true
            };

            this.securityMatrixService.getSecurityMatrixView(this.$scope.securityMatrixId)
                .then((dto) => {
                    this.$scope.securityMatrixViewDto = dto;
                    this.$scope.filterRows();
                });
        }

        private flatRowsToUse(): Wars.Domain.Model.Dtos.FlatSecurityMatrixRowDto[] {
            return this.$scope.criteria.combineLikeRoles ? this.$scope.mergedRows : this.$scope.flatRows;
        }

        private filterRows(): void {
            if (this.$scope.criteria.authorityFilter === undefined || this.$scope.criteria.authorityFilter === 'NONE') {
                this.$scope.flatRows = Enumerable.from(this.$scope.securityMatrixViewDto.flatRows)
                    .where(i => i.statusOrState.toLowerCase().indexOf(this.scope.criteria.statusFilterText.toLowerCase()) !== -1)
                    .toArray();

                this.$scope.mergedRows = Enumerable.from(this.$scope.securityMatrixViewDto.flatMergedRows)
                    .where(i => i.statusOrState.toLowerCase().indexOf(this.scope.criteria.statusFilterText.toLowerCase()) !== -1)
                    .toArray();
            } else {
                this.$scope.flatRows = Enumerable.from(this.$scope.securityMatrixViewDto.flatRows)
                    .where(i => i.statusOrState.toLowerCase().indexOf(this.scope.criteria.statusFilterText.toLowerCase()) !== -1)
                    .where(i => i.authority === this.$scope.criteria.authorityFilter)
                    .toArray();

                this.$scope.mergedRows = Enumerable.from(this.$scope.securityMatrixViewDto.flatMergedRows)
                    .where(i => i.statusOrState.toLowerCase().indexOf(this.scope.criteria.statusFilterText.toLowerCase()) !== -1)
                    .where(i => i.authority === this.$scope.criteria.authorityFilter)
                    .toArray();
            }
        }
    }
}

warsApp.registerController('ViewSecurityMatrixModalController',
    ['$scope', 'securityMatrixService', 'securityMatrixId', 'close']);